export default __webpack_public_path__ + "static/media/229.924a11af.jpg";